import { render, staticRenderFns } from "./period-sales-per-customer.card.vue?vue&type=template&id=54025f08&scoped=true&"
import script from "./period-sales-per-customer.card.vue?vue&type=script&lang=js&"
export * from "./period-sales-per-customer.card.vue?vue&type=script&lang=js&"
import style0 from "./period-sales-per-customer.card.vue?vue&type=style&index=0&id=54025f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54025f08",
  null
  
)

export default component.exports